import { render } from "./PunchingShearDiagram.vue?vue&type=template&id=3af8467c&scoped=true"
import script from "./PunchingShearDiagram.vue?vue&type=script&lang=js"
export * from "./PunchingShearDiagram.vue?vue&type=script&lang=js"

import "./PunchingShearDiagram.vue?vue&type=style&index=0&id=3af8467c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af8467c"]])

export default __exports__